/**
 * Marks everything behind a session as `noindex`.
 *
 * Rendered by `ProtectedRoute`, so it covers the dashboard, profile, entries,
 * participation and the whole admin console through one chokepoint rather than
 * asking every private page to remember. Combined with the `Disallow` rules in
 * robots.txt, a private page is kept out of search results whether or not a crawler
 * respects the robots file.
 */

import { usePageMeta } from '../lib/meta';

export function NoIndex({ title }: { title: string }) {
  usePageMeta({ title, noIndex: true });
  return null;
}
